import { FC, useContext, useEffect, useRef } from "react";
import { Stack, useResponsiveMode } from "@fluentui/react";
import { ITheme } from "cayo.ui";
import styled from "styled-components";
import { IScheme } from "@cayo/shared/api/types/schema";
import alertUtils from "@cayo/shared/components/Alerts/utils";
import { AppContext } from "@cayo/shared/components/App/appContext";
import CompanyLogo from "@cayo/shared/components/schemes/CompanyLogo";
import Breadcrumb from "../Breadcrumb";
import GenericScheme from "./GenericScheme";
import ToggleNavCollapseButton from "../Buttons/ToggleNavCollapseButton";
import Row from "../Layout/Row";
import { isMedium } from "../Nav/nav-hooks";
import { navTreeWidth } from "../Nav/NavTree.Style";

type NavHeaderProps = IScheme & { rootName: string };

const NavHeader: FC<NavHeaderProps> = (props) => {
  const stubRef = useRef(null);
  const mediumMode = isMedium(useResponsiveMode(stubRef));
  const { setFirstAlertButtonId } = useContext(AppContext);

  const { items } = props;

  useEffect(() => {
    if (items?.length) {
      const alertId = alertUtils.getPanelType(items[0].name!);
      if (alertId) {
        setFirstAlertButtonId(alertId);
      }
    }
  }, [items]);

  return (
    <StyledNavContainer key="navheader" data-testid="nav-container">
      <Stack
        horizontal={true}
        verticalAlign="center"
        style={{ width: mediumMode ? "auto" : navTreeWidth }}
        styles={{ root: { flexShrink: mediumMode ? 1 : 0 } }}
      >
        <ToggleNavCollapseButton />
        <LogoWrapper mediumMode={mediumMode}>
          <CompanyLogo />
        </LogoWrapper>
      </Stack>

      <Breadcrumb rootName={props.rootName} />
      <GenericScheme {...props} style={{ width: undefined }} />
    </StyledNavContainer>
  );
};

const StyledNavContainer = styled(Row)`
  background-color: ${(props) => {
    return (
      (props.theme as ITheme).elementStyles.navHeader?.background ||
      (props.theme as ITheme).officeTheme.palette.themePrimary
    );
  }};
  width: 100%;
  height: 65px;
  display: "flex";
  align-items: center;
`;

const LogoWrapper = styled.div<{ mediumMode: boolean }>`
  flex-grow: 1;
  padding-left: ${(props) => (props.mediumMode ? "8px" : "40px")};
  padding-right: ${(props) => (props.mediumMode ? "8px" : 0)};
`;

export default NavHeader;
